// The one place the game's display name lives — every on-screen occurrence imports this instead of
// repeating the string. Directories, package.json and the server keep their existing names: this is a
// display-only rename, not a project rename.
export const GAME_NAME = 'Bestiarum';
